var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-select",
    {
      staticClass: "w-100 webhook-picker",
      attrs: {
        "filter-option": false,
        notFoundContent: "No webhook found",
        placeholder: "Choose a webhook",
        "show-search": "",
        size: "large",
      },
      on: {
        change: _vm.handleChange,
        search: _vm.handleSearch,
        select: _vm.handleSelect,
      },
      model: {
        value: _vm.loading ? "loading" : _vm.selectedHookId,
        callback: function ($$v) {
          _vm.loading ? "loading" : (_vm.selectedHookId = $$v)
        },
        expression: "loading ? 'loading' : selectedHookId",
      },
    },
    [
      _vm.loading
        ? _c("a-select-option", { key: "loading" }, [_vm._v(" Loading ....")])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.getFilteredResult(), function (hook, index) {
        return _c(
          "a-select-option",
          { key: index, attrs: { value: hook._id } },
          [
            _c("div", { staticClass: "item-container" }, [
              _c("div", { staticClass: "title" }, [
                _c(
                  "div",
                  { staticClass: "logo-container" },
                  [
                    _c(
                      "a-avatar",
                      {
                        staticClass: "avatar",
                        style:
                          "background-color:" +
                          (index % 2 === 0 ? "#c980a3" : "#6899c1"),
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(hook.name.slice(0, 2).toUpperCase()) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _vm._v(_vm._s(hook.name)),
                ]),
              ]),
            ]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }